/**
 * `/folders` and `/saved` render the same folders list; `/saved` stays for older links.
 * Folder *detail* is out of scope for the rework and always stays at `/folder/:id` (Part-5 spec);
 * `getFoldersListPath` keeps list-level navigation (e.g. the post-delete reroute) within whichever
 * list namespace the teacher is browsing.
 */
const isV2FoldersPath = (pathname: string): boolean =>
  pathname === '/folders' || pathname.startsWith('/folders/');

export const getFoldersListPath = (pathname: string): string =>
  isV2FoldersPath(pathname) ? '/folders' : '/saved';

export const getFolderDetailPath = (folderId: string): string => `/folder/${folderId}`;
